module.exports = __webpack_public_path__ + "img/item(12).86890195.svg";